import { observable, action, decorate } from 'mobx'
import axios from 'axios'

class EditNfeStore {
  constructor () {
    this.state = {
      id: '',
      data: {
        cliente: '',
        alias: '',
        ativo: true,
        dir_xml: '',
        email: '',
        downloads: []
      },
      isUpdating: false,
      modalIsActive: false
    }
  }

  openModal () {
    this.state.modalIsActive = true
  }

  closeModal () {
    this.state.modalIsActive = false
  }

  handleChange(value, name) {
    this.state.data[name] = value
  }

  toggleActive () {
    this.state.data.ativo = !this.state.ativo
  }

  setFormData (data, id) {
    this.state.id = id
    this.state.data.downloads = data.downloads
    this.state.data.cliente = data.cliente
    this.state.data.alias = data.alias
    this.state.data.ativo = data.ativo
    this.state.data.dir_xml = data.dir_xml
    this.state.data.email = data.email
  }
}

decorate(EditNfeStore, {
  state: observable
})

export default EditNfeStore



// WEBPACK FOOTER //
// ./src/stores/config/companies/products/editNfeStore.js